export default {
	username: '',
	hasRoomData: false,
	roomData: null,
	players: [],
	votes: []
}
